import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableFooter from "@mui/material/TableFooter";
import IconButton from "@mui/material/IconButton";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";  // Import the icon
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useUnassignedRentalUnits } from "services/hooks/rentals";
import { useSelector } from "react-redux";
import UnassgnedUnitsPopover from "components/PopOvers/UnassignedUnitsPopover";
import AddTenantsFromUnoccupiedForm from "components/Forms/AddTenantsFromUnoccupiedListForm";
import moment from "moment";
import FormDialog from "components/modal";
import * as yup from 'yup';
import { baseURL } from "services/API";
import axios from "axios";
import { StyledTableCell, StyledTableRow } from "./Styles/TableAndCellStyles";
import { useMediaQuery, Stack } from "@mui/material";
import { FaRegEye } from "react-icons/fa";
import { IoMdEyeOff } from "react-icons/io";

export default function UnassignedUnitsTable() {
  const id = useSelector((state) => state.property_id);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [anchorEl, setAnchorEl] = React.useState(null); // For the popover
  const [activeUnit, setActiveUnit] = React.useState(null); // Store active unit for popover
  const openPopper = Boolean(anchorEl);
  const popperId = openPopper ? "simple-popover" : undefined;
  const [modal, setModal] = React.useState("");
  const [details, setDetails] = React.useState("");
	const [open, setOpen] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [openSnack, setOpenSnack] = React.useState({open: false,vertical: "top",horizontal: "center",});
  const [severity, setSeverity] = React.useState("");
	const [isLoadedUnits, setIsLoadedUnits] = React.useState(false);
  const [activeID, setActiveID] = React.useState(null);
  const [showDetails, setShowDetails] = React.useState(false);
  const navigate = useNavigate();
  const { unassignedRentalUnits, isLoadingUnassignedRentalUnits, error, setNewData } = useUnassignedRentalUnits(id);
  const isNonMobileScreen = useMediaQuery("(min-width:600px)");
	const [tenantDetails, setTenantDetails] = React.useState({});
	const [loadedTenant, setLoadedTenant] = React.useState(false);
	const [loadingTenantsError, setLoadingTenantsError] = React.useState("");
	const [isExistingTenant, setIsExisitingTenant] = React.useState(true);
	const [loadingTenantDetails, setLoadingTenantDetails] = React.useState(true);
  const [errorLoadingTenantDetails, setErrorLoadingTenantDetails] = React.useState(false);
	const [newTenantDetails, setNewTenantDetails] = React.useState({next_payment_date:moment().add(1, 'day').format('YYYY-MM-DD'),start_date:moment().format('YYYY-MM-DD'), expected_payment_date: moment().format('YYYY-MM-DD'),first_name: "",last_name: "",tenant_number: "",phone_number:"",unit_id: "", rent_backlog_description:"", rent_backlog_amount:0, rent_balance_carried_forward_amount:0});

	const [isBrandNewTenant, setIsBrandNewTenant] = React.useState(true);
	const [hasPaymentBacklog, setHasPaymentBacklog] = React.useState(false);
	const [isInitialPaymentMade, setIsInitialPaymentMade] = React.useState(false);
	const [isOutstandingBalance, setIsOutstandingBalance] = React.useState(true);
	const [isPreExistingTenant, setIsPreExistingTenant] = React.useState(false);

	const handleHasPaymentBacklog = () =>{
		setHasPaymentBacklog(!hasPaymentBacklog);
		setNewTenantDetails((prev) => ({ ...prev, has_payment_backlog: !hasPaymentBacklog }));
	}

	const handlePreExistingTenantRadio = () => {
    console.log("PreExistingTenantRadio")
		setIsBrandNewTenant(false);
		setIsPreExistingTenant(true);
		setNewTenantDetails((prev) => ({
			...prev,
			is_brand_new_tenant: false,
			has_payment_backlog: true,
			start_date: prev.next_payment_date, // set start_date to next_payment_date
		}));
	};

	const handleChangeTenantType = (e) => {
		setIsBrandNewTenant(e);
		if (e) {
			// Switching back to "Brand New Tenant" — reset pre-existing state so payload stays correct
			setIsPreExistingTenant(false);
			setHasPaymentBacklog(false);
			setNewTenantDetails((prev) => ({
				...prev,
				is_brand_new_tenant: true,
				has_payment_backlog: false,
				start_date: moment().format("YYYY-MM-DD"),
			}));
		} else {
			setNewTenantDetails((prev) => ({ ...prev, is_brand_new_tenant: e }));
		}
	};

	const handleChangeIsInitialPaymentMade = ()=>{
		setIsInitialPaymentMade(!isInitialPaymentMade);
		setNewTenantDetails((prev) => ({ ...prev, is_initial_payment_made: !isInitialPaymentMade }));
	}

  const handleChangeBalanceType = (status) =>{

	console.log("status", status);
		setIsOutstandingBalance(status);
		if (status) {
			// Outstanding Balance selected - clear balance carried forward
			setNewTenantDetails((prev) => ({ ...prev, is_outstanding_balance: status, rent_balance_carried_forward_amount: 0 }));
		} else {
			// Balance Carried Forward selected - clear outstanding balance, preserve balance carried forward if it exists
			setNewTenantDetails((prev) => ({ 
				...prev, 
				is_outstanding_balance: status, 
				rent_backlog_amount: 0,
				rent_balance_carried_forward_amount: prev.rent_balance_carried_forward_amount || 0
			}));
		}
		
	}
  
  
  const toggleDetailsView = (rowId) => {
    setActiveID(rowId);
    setShowDetails(!showDetails);
  };

  const handleClickPopOver = (event, unit) => {
    setAnchorEl(event.currentTarget);
    setActiveUnit(unit); // Set the active unit for the popover
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClosePopOver = () => {
    setAnchorEl(null);
  };

  const handleModalView = (modalView) => {
		if(modalView==='addTenant'){
			setNewTenantDetails((prev) => ({ 
				...prev, 
				unit_id: activeUnit.related_rental_unit.id,
				is_initial_payment_made: isInitialPaymentMade,
				periods_covered_initially: activeUnit.down_payment_periods_covered,
				is_brand_new_tenant: isBrandNewTenant, 
				has_payment_backlog: hasPaymentBacklog,
				security_deposit_amount: 0,
				rent_amount_paid: activeUnit.unit_cycle_down_payment,
				total_deposit_amount: parseFloat(activeUnit.unit_cycle_down_payment) + 0,
			}));
		}
		setModal(modalView);
	};

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function toSentenceCase(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  

  const handleClose = () => {
		setModal("");
		setErrors({});
		setOpen(false);
		setLoadedTenant(false);
		setIsExisitingTenant(true);
		setIsLoadedUnits(false);
		setIsInitialPaymentMade(false);
		setHasPaymentBacklog(false);
		setIsBrandNewTenant(true);
		setNewTenantDetails({rent_deposit_amount: 0, next_payment_date:moment().add(1, 'day').format('YYYY-MM-DD'), start_date:moment().format('YYYY-MM-DD'),expected_payment_date: moment().format('YYYY-MM-DD'), first_name: "",last_name: "",tenant_number: "",phone_number:"",unit_id: "",rent_backlog_description:"",rent_backlog_amount:0, rent_balance_carried_forward_amount:0});
	};

	const handleChangeTenantDetails = (event) => {
		const { name, value } = event.target;
		console.log("handleChangeTenantDetails - name:", name, "value:", value, "type:", typeof value);
		
		// For numeric fields, ensure we store the value (can be string from input, that's fine)
		const numericFields = ['rent_backlog_amount', 'rent_balance_carried_forward_amount', 'security_deposit_amount', 'rent_amount_paid', 'total_deposit_amount', 'periods_covered_initially'];
		const processedValue = numericFields.includes(name) ? (value === '' ? 0 : value) : value;
		
		console.log("handleChangeTenantDetails - processedValue:", processedValue);
		
    	setNewTenantDetails((prev) => {
			const updated = { ...prev, [name]: processedValue };
			console.log("handleChangeTenantDetails - Updated state:", updated);
			console.log("handleChangeTenantDetails - rent_balance_carried_forward_amount in state:", updated.rent_balance_carried_forward_amount);
			return updated;
		});
		
		if (!toString(value).trim()) {
      		setErrors((prev) => ({ ...prev, [name]: `${name} is required`}));
		} else {
			setErrors((prev) => ({ ...prev, [name]: '' }));
		}
	};

  const handleIncludeSecurityDeposit = (include) => {
		const hasSecurityFee = parseFloat(activeUnit?.unit_rent_security_fee) > 0;
		const amount = include
			? (hasSecurityFee ? parseFloat(activeUnit.unit_rent_security_fee) : parseFloat(activeUnit?.unit_rent) || 0)
			: 0;
		setNewTenantDetails((prev) => ({
			...prev,
			security_deposit_amount: amount,
			total_deposit_amount: parseFloat(prev.rent_amount_paid) + amount,
		}));
	};

	const handleChangePeriodsCovered=(e)=>{
		const {value} = e.target
		const rentAmount = parseFloat(value) * parseFloat(activeUnit.unit_rent); 
		setNewTenantDetails((prev) => ({ ...prev, periods_covered_initially : value, rent_amount_paid: rentAmount, total_deposit_amount: rentAmount + parseFloat(prev.security_deposit_amount) }));
	}

	const handleChangeTenantNumber = async (e) => {
		setLoadedTenant(false);
		setIsExisitingTenant(true);
		setIsLoadedUnits(false);
		setLoadingTenantsError("");
		setNewTenantDetails((prev) => ({ ...prev, first_name: "", last_name: "" }));
		const phone_number = e.target.value;
		if (!phone_number.trim()) {
      		setErrors((prev) => ({ ...prev, 'phone_number': `The Tenant's phone number is required`}));
		} else {
			setErrors((prev) => ({ ...prev, 'phone_number': '' }));
		}
		if (phone_number.length === 12) {
			setNewTenantDetails((prev) => ({ ...prev, 'phone_number': phone_number }));
			try {
				const response = await axios.get(`${baseURL}/tenants?username=${phone_number}`);
				setTenantDetails(response.data.data);
        setNewTenantDetails((prev)=> ({...prev, tenant_number: response.data.data.tenant_number, tenant_id: response.data.data.id}))
				setLoadedTenant(true);
				setLoadingTenantDetails(false);
				setLoadingTenantsError("");
				return true;
			} catch (err) {
				setIsExisitingTenant(false);
				setLoadingTenantDetails(false);
				setErrorLoadingTenantDetails(true);
				setLoadingTenantsError("");
				return false;
			}
		} else {
			setLoadingTenantsError("Please type a complete phone number with 12 digits including 256");
			setNewTenantDetails((prev) => ({ ...prev, "first_name": "", "last_name": "" }));
		}
	};

  const handleSubmitDelete = async () => {
    try {
      const response = await axios.delete(`${baseURL}/landlords/rentals/units/delete?unit_id=${activeUnit.id}`);

      setOpenSnack({ ...openSnack, open: true });
      setSeverity("success");
      setMessage("Unit Deleted Successfully");
      setNewData(true);
    } catch (err) {
      setOpenSnack({ ...openSnack, open: true });
      setSeverity("error");
      setMessage("Unit Delete failed, Please check unit details");
    }
  };

	const [errors, setErrors] = React.useState({});
	const propertySchema = isExistingTenant ? yup.object().shape({
		unit_id: yup.string().required("Please select a unit attached to the property above"),
		tenant_id: yup.number().required(),
		tenant_number: yup.string().required("Input a the tenant's phone number to start the process"),
		phone_number: yup.string().required("Input a the tenant's phone number to start the process"),
		total_deposit_amount: yup.number().required("This field is required"),
		is_initial_payment_made: yup.boolean().required("This is required"),
		rent_amount_paid:yup.number().required("This is required"),
		periods_covered_initially: yup.number().required("This field is required"),
		rent_backlog_amount: yup.number().when(['is_outstanding_balance', 'has_payment_backlog'], {
			is: (is_outstanding_balance, has_payment_backlog)=> is_outstanding_balance===true && has_payment_backlog===true,
			then: yup.number().min(1, 'Please enter the outstanding balance').required("This field is required")
		}),
		rent_balance_carried_forward_amount: yup.number().when(['is_outstanding_balance', 'has_payment_backlog'],  {
			is: (is_outstanding_balance, has_payment_backlog)=> is_outstanding_balance===false && has_payment_backlog===true,
			then: yup.number().min(1, 'Please enter the balance carried forward').required("This field is required")
		}),
		has_payment_backlog: yup.boolean(),
		is_outstanding_balance: yup.boolean(),
		rent_backlog_description: yup.string(),
		start_date: yup.date().required("This field is required"),
		next_payment_date: yup.date().required("This field is required"),
	}) : yup.object().shape({
		unit_id: yup.string().required("Please select a unit attached to the property above"),
		phone_number: yup.string().required("Input a the tenant's phone number to start the process"),
		first_name: yup.string().required("Input the tenant's First Name"),
		last_name: yup.string().required("Input the tenant's Last Name"),
		total_deposit_amount: yup.number().required("This field is required"),
		is_initial_payment_made: yup.boolean().required("This is required"),
		rent_amount_paid:yup.number().required("This is required"),
		periods_covered_initially: yup.number().required("This field is required"),
		rent_backlog_amount: yup.number().when(['is_outstanding_balance', 'has_payment_backlog'], {
			is: (is_outstanding_balance, has_payment_backlog)=> is_outstanding_balance===true && has_payment_backlog===true,
			then: yup.number().min(1, 'Please enter the outstanding balance').required("This field is required")
		}),
		rent_balance_carried_forward_amount: yup.number().when(['is_outstanding_balance', 'has_payment_backlog'],  {
			is: (is_outstanding_balance, has_payment_backlog)=> is_outstanding_balance===false && has_payment_backlog===true,
			then: yup.number().min(1, 'Please enter the balance carried forward').required("This field is required")
		}),
		has_payment_backlog: yup.boolean(),
		rent_backlog_description: yup.string(),
		is_outstanding_balance: yup.boolean(),
		start_date: yup.date().required("This field is required"),
		next_payment_date: yup.date().required("This field is required"),

	}) ;

	const handleSubmitTenant = async () => {
		try {
			await propertySchema.validate(newTenantDetails, {abortEarly:false});
		} catch (error) {
			const newError = {}
			error.inner.forEach(err => {
				newError[err.path]=err.message
			})
			setErrors(newError)
			console.log(newError)
			return
		}
		let createTenant
		try {
			if (!isExistingTenant) {
				createTenant = await axios.post(`${baseURL}/accounts/users`, {
					first_name: newTenantDetails.first_name,
					last_name: newTenantDetails.last_name,
					email: "dummy@email.com",
					phone_number: newTenantDetails.phone_number.slice(3),
					password: "@Rent123",
					username: `+${newTenantDetails.phone_number}`,
        		});
			}
				
			// Log before API call to debug balance_carried_forward
			console.log("=== API SUBMISSION DEBUG ===");
			console.log("isPreExistingTenant:", isPreExistingTenant);
			console.log("has_payment_backlog:", isPreExistingTenant ? true : newTenantDetails.has_payment_backlog);
			console.log("rent_balance_carried_forward_amount (raw):", newTenantDetails.rent_balance_carried_forward_amount);
			console.log("rent_balance_carried_forward_amount (type):", typeof newTenantDetails.rent_balance_carried_forward_amount);
			console.log("newTenantDetails full object:", newTenantDetails);
			
			const hasBacklog = isPreExistingTenant || newTenantDetails.has_payment_backlog;
			const balanceAmount = newTenantDetails.rent_balance_carried_forward_amount;
			const parsedAmount = parseFloat(balanceAmount) || 0;
			const balanceCarriedForward = (hasBacklog && parsedAmount > 0) ? parsedAmount : 0;
			
			console.log("hasBacklog:", hasBacklog);
			console.log("balanceAmount:", balanceAmount);
			console.log("parsedAmount:", parsedAmount);
			console.log("balanceCarriedForward (final):", balanceCarriedForward);
			console.log("============================");
			
			const response = await axios.post(`${baseURL}/landlords/rentals/units/assign`, {
				unit_id: newTenantDetails.unit_id,
				tenant_id: !isExistingTenant ? createTenant.data.data.id : newTenantDetails.tenant_id,
				is_brand_new_tenant: newTenantDetails.is_brand_new_tenant,
				is_initial_payment_made: newTenantDetails.is_initial_payment_made,
				total_deposit_amount: newTenantDetails.total_deposit_amount,
    		security_deposit_amount: newTenantDetails.security_deposit_amount,
				rent_amount_paid: newTenantDetails.rent_amount_paid, 
				periods_covered_initially:newTenantDetails.periods_covered_initially, 
				has_payment_backlog: isPreExistingTenant ? true : newTenantDetails.has_payment_backlog, // <-- always true for pre-existing
				rent_backlog_amount: newTenantDetails.rent_backlog_amount,
				rent_balance_carried_forward_amount: newTenantDetails.rent_balance_carried_forward_amount,
				balance_carried_forward: balanceCarriedForward,
				rent_backlog_description: newTenantDetails.rent_backlog_description,
				start_date: isPreExistingTenant ? newTenantDetails.next_payment_date : newTenantDetails.start_date, // <-- set as required
				next_payment_date:newTenantDetails.next_payment_date,
				expected_payment_date: newTenantDetails.expected_payment_date
			});

			setOpen(false);
			setOpenSnack({ ...openSnack, open: true});
			setSeverity("success");
			setMessage("Tenant Added Successfully");
			// dispatch(setRefreshCount());
			setLoadedTenant(false);
			setIsExisitingTenant(true);
			setIsLoadedUnits(false);
      setNewData(true);
			setNewTenantDetails({
				rent_deposit_amount: 0, 
				months_covered:1, 
				next_payment_date:moment().format('YYYY-MM-DD'),
				first_name: "",
				last_name: "",
				tenant_number: "",
			  phone_number:"",
				unit_id: "",
			});
		} catch (err) {
			setOpenSnack({ ...openSnack, open: true});
			setSeverity("error");
			setMessage("Tenant Addition failed: " + err.response.data.error);
		}
	};

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Box sx={{ flexGrow: 1, padding: "2rem" }}>
          <Typography variant="h4" gutterBottom>
            Unassigned Rental Units
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Unit Name</StyledTableCell>
                  {isNonMobileScreen && 
                    <>
                      <StyledTableCell align="left">Unit Type</StyledTableCell>
                      <StyledTableCell align="left">Unit Size(m2)</StyledTableCell>
                      <StyledTableCell align="left">Rent Currency</StyledTableCell>
                      <StyledTableCell align="left">Unit Rent</StyledTableCell>
                      <StyledTableCell align="left">Unit Rent Cycle</StyledTableCell>
                    </>
                  }
                  <StyledTableCell align="left">Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoadingUnassignedRentalUnits ? (
                  <StyledTableRow>
                    {/* Loading Spinner or Empty Row */}
                  </StyledTableRow>
                ) : (
                  <>
                    {unassignedRentalUnits.length > 0 ? (
                      unassignedRentalUnits
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                          <StyledTableRow key={row.id}>
                            <StyledTableCell component="th" scope="row">
                              {row.related_rental_unit.unit_name}
                              {
                                !isNonMobileScreen && 
                                <Stack spacing={1} style={{ fontSize: "16px", marginTop: "7px" }}>
                                  <span style={{ cursor: "pointer", display: "flex", alignItems: "center", fontSize: "15px" }} onClick={() => toggleDetailsView(row.id)}>
                                    See{" "}
                                    {activeID === row.id && showDetails ? (
                                      <>
                                        less <IoMdEyeOff style={{ marginLeft: "5px", marginTop: "1px" }} />
                                      </>
                                    ) : (
                                      <>
                                        more <FaRegEye style={{ marginLeft: "5px", marginTop: "1px" }} />
                                      </>
                                    )}
                                  </span>
                                  {activeID === row.id && showDetails && (
                                    <>
                                      <span><strong>Type:</strong> {toSentenceCase(row.related_rental_unit.unit_type)}</span>
                                      <span><strong>Size:</strong> {toSentenceCase(row.related_rental_unit.unit_size)}</span>
                                      <span><strong>Currency:</strong> {row.rent_currency}</span>
                                      <span><strong>Rent:</strong> {row.unit_rent}</span>
                                      <span><strong>Rent Cycle:</strong> {toSentenceCase(row.unit_rent_cycle)}</span>
                                    </>
                                  )}
                                </Stack>
                              }
                            </StyledTableCell>
                            {isNonMobileScreen && 
                              <>
                                <StyledTableCell align="left">{toSentenceCase(  row.related_rental_unit.unit_type)}</StyledTableCell>
                                <StyledTableCell align="left">{row.related_rental_unit.unit_size}</StyledTableCell>
                                <StyledTableCell align="left">{row.rent_currency}</StyledTableCell>
                                <StyledTableCell align="left">{row.unit_rent}</StyledTableCell>
                                <StyledTableCell align="left">{toSentenceCase(row.unit_rent_cycle)}</StyledTableCell>
                              </>
                            }
                            <StyledTableCell>
                              <IconButton
                                color="primary"
                                size="small"
                                aria-describedby={popperId}
                                onClick={(event) =>
                                  handleClickPopOver(event, row)
                                }
                              >
                                <MoreHorizIcon />
                              </IconButton>
                            </StyledTableCell>
                          </StyledTableRow>
                        ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell colSpan={7}>
                          No data Available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>{/* Pagination can go here */}</TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          {/* UnitsPopover for handling actions */}
          <UnassgnedUnitsPopover
            popperId={popperId}
            openPopper={openPopper}
            anchorEl={anchorEl}
            handleModalView={handleModalView}
            handleClosePopOver={handleClosePopOver}
            handleClickOpen={handleClickOpen}
            activeUnit={activeUnit}
            navigate={navigate}
          />
        </Box>
      </Box>
      {modal === "addTenant" ? (
        <FormDialog
          open={open}
          handleClose={handleClose}
          enableActions={true}
          content={
            <AddTenantsFromUnoccupiedForm
              handleChangeTenantNumber={handleChangeTenantNumber}
              tenant={tenantDetails}
              errorTenant={errorLoadingTenantDetails}
              loadedTenant={loadedTenant}
              errors={errors}
              unit={activeUnit}
              hasPaymentBacklog={hasPaymentBacklog}
              handleHasPaymentBacklog={handleHasPaymentBacklog}
              handleChangeIsInitialPaymentMade={handleChangeIsInitialPaymentMade}
              calculatedValues={newTenantDetails}
              isBrandNewTenant={isBrandNewTenant}
              handleChangeTenantType={handleChangeTenantType}
              handleIncludeSecurityDeposit={handleIncludeSecurityDeposit}
			        handleChangePeriodsCovered={handleChangePeriodsCovered}
              isExistingTenant={isExistingTenant}
              isOutstandingBalance={isOutstandingBalance}
              isInitialPaymentMade={isInitialPaymentMade}
              handleChangeBalanceType={handleChangeBalanceType}
              handleChangeTenantDetails={handleChangeTenantDetails}
              loadingTenantsError={loadingTenantsError}
              isPreExistingTenant={isPreExistingTenant}
              handlePreExistingTenantRadio={handlePreExistingTenantRadio}
            />
          }
          title={`Attach Tenant to ${activeUnit.related_rental_unit.unit_name}`}
          handleSubmit={handleSubmitTenant}
          buttonText="submit"
          buttonClass={"add-button"}
        />
      ) : modal === "delete" ? (
        <FormDialog
          title="Delete Unit"
          enableActions={true}
          open={open}
          content="Are you sure you want to delete this Unit?"
          handleSubmit={handleSubmitDelete}
          handleClose={handleClose}
          buttonText="Delete Unit"
        />
      ) : null}
    </Box>
  );
}
